import React, { FC } from "react";
import { IAcompanhamento, IMatricula } from "@deltasge/marauders-map";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import {
  AccountSearchOutline as AccountSearchIcon,
  Printer as PrintIcon,
} from "mdi-material-ui";
import { Avatar } from "components/Avatar";

export const ConselhoAluno: FC<{
  titulo: string;
  matricula?: IMatricula;
  pareceres: IAcompanhamento[];
  loading: boolean;
  onImprimir: () => void;
}> = ({ titulo, matricula, pareceres, loading, onImprimir }) => {
  const registros = pareceres.filter(
    (parecer) => (parecer.texto ?? "").trim().length > 0
  );
  const hasData = registros.length > 0;
  const nome = matricula?.aluno?.nomeusual || matricula?.aluno?.nome || "";

  if (!matricula) {
    return (
      <Box sx={{ textAlign: "center", py: 10, color: "#999" }}>
        <AccountSearchIcon sx={{ fontSize: 48, opacity: 0.3 }} />
        <Typography>
          Selecione um aluno no filtro lateral para visualizar o relatório
          único.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <Box>
          <Typography variant="h5" color="primary">
            Relatório Único por Aluno
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {titulo}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<PrintIcon />}
          onClick={onImprimir}
          disabled={!hasData}
        >
          Imprimir Relatório
        </Button>
      </Box>

      <Paper
        sx={{ p: 4, border: "1px solid #e0e0e0", boxShadow: "none" }}
        variant="outlined"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 4,
            pb: 2,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Avatar
            displayName={nome}
            src={matricula.aluno?.imagemAluno?.caminhoArquivo ?? undefined}
            sx={{ width: 56, height: 56, mr: 2 }}
          />
          <Box>
            <Typography variant="h6" fontWeight="bold">
              {nome}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Pareceres de Todos os Professores
            </Typography>
          </Box>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : hasData ? (
          registros.map((parecer) => (
            <Box
              key={`relatorio_aluno_${parecer.id}`}
              sx={{ mb: 3, pl: 2, borderLeft: "3px solid #00838f" }}
            >
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{ color: "#555", textTransform: "uppercase" }}
              >
                {parecer.materia?.nome}
              </Typography>
              <Typography
                variant="body1"
                sx={{ mt: 0.5, color: "#333", whiteSpace: "pre-wrap" }}
              >
                {parecer.texto}
              </Typography>
            </Box>
          ))
        ) : (
          <Box sx={{ textAlign: "center", py: 4, color: "#999" }}>
            <Typography>
              Nenhum parecer individual registrado para este aluno até o
              momento.
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};
